export const sanitizeFilename = (name: string): string => {
  return name.replace(/[^a-zA-Z0-9.-]/g, '_').slice(0, 100)
}
